import { render, staticRenderFns } from "./MobileTopMenu.vue?vue&type=template&id=85ebc098&scoped=true&"
import script from "./MobileTopMenu.vue?vue&type=script&lang=js&"
export * from "./MobileTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileTopMenu.vue?vue&type=style&index=0&id=85ebc098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ebc098",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
